<template>
  <div>
    <ed-modal
      :title="
        formData.id == 0
          ? 'Novo GHE'
          : this.$store.state.ltcat.title +
            formData.ghe +
            ' (' +
            formData.descricao +
            ')'
      "
      :modal="showFormEdit"
      :loadingSave="config.loading.save"
      :onClose="onClose"
      :onSave="tagConfig == 'tab-cadastro' ? this.salvar : null"
      width="98%"
    >
      <div slot="modal-content" v-loading="config.loading.content">
        <el-tabs type="card" v-model="tagConfig">
          <el-tab-pane label="Config" name="tab-cadastro">
            <span slot="label">
              <i class="fa fa-list-alt"></i> Informações do GHE
            </span>

            <ed-form
              :data="formData"
              :config="config"
              :response="response"
              :itens="formItems"
            >
              <div slot="form-footer"></div>
            </ed-form>
          </el-tab-pane>

          <el-tab-pane label="Config" name="tab-risco" v-if="formData.id > 0">
            <span slot="label">
              <i class="fa fa-exclamation-triangle"></i> Medições ({{
                formData.medicoes.length
              }})
            </span>
            <Medicao :parent="this" :ltcat="parent.ltcat" />
          </el-tab-pane>

          <el-tab-pane
            label="Config"
            name="tab-conclusao"
            v-if="formData.id > 0"
          >
            <span slot="label">
              <i class="fa fa-wpforms"></i> Conclusão Técnica ({{
                formData.conclusoes.length
              }})
            </span>
            <ConclusaoTecnica :parent="this" :ltcat="parent.ltcat" />
          </el-tab-pane>

          <el-tab-pane label="Config" name="tab-funcao" v-if="formData.id > 0">
            <span slot="label">
              <i class="fa fa-users"></i> Funções ({{
                formData.funcoes.length
              }})
            </span>
            <Funcao :parent="this" :ltcat="parent.ltcat" />
          </el-tab-pane>

          <el-tab-pane
            label="Config"
            name="tab-funcionarios"
            v-if="formData.id > 0"
          >
            <span slot="label">
              <i class="fa fa-address-card"></i> Funcionário ({{
                formData.funcionarios.length
              }})
            </span>
            <Funcionario :parent="this" :ltcat="parent.ltcat" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </ed-modal>
  </div>
</template>

<script>
import Rest from "common/rest";
import EdForm from "common/form";
import EdModal from "common/modal";
import FormItems from "./_form/ltcat-ghe-editar";
import Funcao from "./funcao";
import Funcionario from "./funcionario";
import Medicao from "./medicao";
import ConclusaoTecnica from "./conclusao-tecnica";

export default {
  name: "empresa",
  components: {
    EdForm,
    EdModal,
    Funcao,
    Funcionario,
    Medicao,
    ConclusaoTecnica,
  },
  mixins: [Rest],
  props: {
    parent: {
      type: Object,
      default: null,
    },
  },
  watch: {
    "parent.showFormEdit"() {
      this.showFormEdit = !this.showFormEdit;
      this.inicialize();
    },
    "$store.state.ltcat.data.id"() {
      this.inicialize();
    },
  },
  data() {
    return {
      config: {
        click: {
          copiar: this.getGhe,
        },
        loading: {
          save: false,
          config: false,
          copiar: false,
        },
        list: {
          copiar: [],
        },
      },
      response: {},
      formItems: [],
      formData: {
        id: 0,
        ordem: 1,
        ghe: null,
        descricao: null,
        obs: null,
        descricao_ambiente_trabalho: null,
        copiar: null,
        updated_at: null,
        usuario: null,
        ordenar: 0,
        funcoes: [],
        medicoes: [],
        conclusoes: [],
        funcionarios: [],
      },
      tagConfig: "tab-cadastro",
      title: null,
      showFormEdit: false,
    };
  },

  created() {},

  mounted() {
    this.formItems = FormItems;
  },
  methods: {
    inicialize(formData) {
      this.formData = Object.assign(
        {},
        formData ? formData : this.parent.formData
      );
      this.tagConfig = "tab-cadastro";
      this.getGhe();
    },

    onClose() {
      this.parent.getLtcat();
    },

    getGhe(_search) {
      this.config.loading.copiar = true;
      this.config.list.copiar = [];

      this.get("ltcat/ghe/" + this.$store.state.ltcat.data.id, {
        search: _search,
      }).then((result) => {
        result = result[0];
        this.config.loading.copiar = false;

        if (result.status == 200) {
          this.config.list.copiar = result.data.data;
        }
      });
    },

    salvar() {
      this.config.loading.save = true;
      this.response = {};

      this.post(
        "/ltcat/ghe/" + this.$store.state.ltcat.data.id + "/editar",
        this.formData
      ).then((result) => {
        result = result[0];

        this.config.loading.save = false;
        this.response = result;

        if (result.status == 200) {
          this.edMsg("Dados atualizados");
          this.inicialize(result.data);
          this.parent.getLtcat();
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// editar.vue?2ee1146e